// extracted by mini-css-extract-plugin
export default {"newLine":"I0xqsr","divider":"tEa7k_"};